import { jsx as t, jsxs as p } from "react/jsx-runtime";
import { Box as r } from "@mui/material";
import "react";
import "@mui/material/styles";
import "@mui/material/CssBaseline";
import { d as s, I as h, c as x } from "./Slider-vVmtecg6.js";
import { s as i } from "./spacings-C27fg6SF.js";
import "@mui/material/useAutocomplete";
import "@fortawesome/pro-regular-svg-icons";
import "@emotion/cache";
import "@emotion/react";
import "@mui/material/Box";
import { T as m } from "./Typography-HkIo7ajX.js";
import "@fortawesome/fontawesome-svg-core";
import "@mui/material/Checkbox";
import "@fortawesome/pro-solid-svg-icons";
import "@fortawesome/pro-light-svg-icons";
import "@mui/material/Stack";
import "@mui/material/Link";
import "@mui/material/Tooltip";
import "@mui/material/Fade";
import { faXmark as u } from "@fortawesome/pro-regular-svg-icons/faXmark";
import "@mui/material/Button";
import "@fortawesome/pro-solid-svg-icons/faCircle";
import "@mui/material/Chip";
import "@mui/material/Avatar";
import "@fortawesome/pro-light-svg-icons/faUser";
import "@mui/material/AvatarGroup";
import "@fortawesome/pro-regular-svg-icons/faPlus";
import "@mui/material/LinearProgress";
import "@mui/material/Tabs";
import "@mui/material/Tab";
import "./Tab-CO75KpXL.js";
import "@mui/material/ButtonGroup";
import "@mui/material/Switch";
import "@mui/material/Radio";
import "@mui/material/FormLabel";
import "@mui/material/Autocomplete";
import "@mui/material/FormHelperText";
import "@mui/material/FormControl";
import "@mui/material/OutlinedInput";
import "@mui/material/Input";
import "@mui/material/InputAdornment";
import "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import "@fortawesome/pro-solid-svg-icons/faCheck";
import "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import "@react-spring/web";
import "./ContentPanel-DRC79oum.js";
import "react-dropzone";
import "@vidstack/react";
import "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import "@vidstack/react/icons";
import "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import "@fortawesome/pro-solid-svg-icons/faArrowRight";
import "@mui/material/Popper";
import "@fortawesome/pro-regular-svg-icons/faLinkSimple";
import "copy-text-to-clipboard";
import "@fortawesome/pro-solid-svg-icons/faExpandWide";
import "@fortawesome/pro-solid-svg-icons/faCompressWide";
import "@fortawesome/pro-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import "@fortawesome/pro-solid-svg-icons/faDownLeftAndUpRightToCenter";
import "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import "@fortawesome/pro-solid-svg-icons/faChevronsLeft";
import "@fortawesome/pro-solid-svg-icons/faToggleLargeOn";
import "@fortawesome/pro-solid-svg-icons/faToggleOff";
import "@fortawesome/pro-solid-svg-icons/faEye";
import "react-use";
import "color";
import "react-rnd";
import "react-hotkeys-hook";
import "./AutoScrollContainer-CzyjIY1o.js";
import "@tanstack/react-table";
import "@fortawesome/pro-regular-svg-icons/faArrowRight";
import "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import "@fortawesome/pro-regular-svg-icons/faArrowDown";
import "@mui/material/Slider";
const Ft = ({
  isMobileView: o,
  onClose: a,
  authorName: l,
  shouldHideCreatorIdentity: n = !1,
  onSingUpClick: c
}) => {
  const e = n ? "the creator" : l;
  return /* @__PURE__ */ t(
    r,
    {
      bgcolor: "rgba(0, 0, 0, 0.6)",
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ p(
        r,
        {
          bgcolor: (d) => d.palette.background.paper,
          borderRadius: "8px",
          maxWidth: o ? "calc(100% - 16px)" : "280px",
          width: "100%",
          height: "auto",
          maxHeight: `calc(100% - ${o ? 16 : 40}px)`,
          overflow: "hidden",
          position: "relative",
          p: i[o ? "lg" : "3xl"],
          children: [
            /* @__PURE__ */ t(
              r,
              {
                position: "absolute",
                top: i.xl,
                right: i.xl,
                children: /* @__PURE__ */ t(
                  s,
                  {
                    onClick: a,
                    size: "small",
                    variant: "text",
                    label: "close",
                    color: "secondary",
                    children: /* @__PURE__ */ t(h, { icon: u })
                  }
                )
              }
            ),
            /* @__PURE__ */ t(
              r,
              {
                display: "flex",
                justifyContent: "center",
                children: /* @__PURE__ */ t(
                  m,
                  {
                    variant: "heading",
                    size: "sm",
                    color: "text.primary",
                    children: "Sign up"
                  }
                )
              }
            ),
            /* @__PURE__ */ t(
              r,
              {
                mt: i.xl,
                display: "flex",
                justifyContent: "center",
                children: o ? /* @__PURE__ */ p(
                  m,
                  {
                    variant: "text",
                    size: "sm",
                    color: "text.primary",
                    children: [
                      "to let ",
                      e,
                      " know you watched their guidde"
                    ]
                  }
                ) : /* @__PURE__ */ p(
                  m,
                  {
                    variant: "text",
                    size: "sm",
                    color: "text.primary",
                    children: [
                      "and let ",
                      e,
                      " know you watched their guidde"
                    ]
                  }
                )
              }
            ),
            /* @__PURE__ */ t(
              r,
              {
                display: "flex",
                mt: i[o ? "md" : "xl"],
                children: /* @__PURE__ */ t(
                  x,
                  {
                    onClick: c,
                    size: "small",
                    fullWidth: !0,
                    color: "primary",
                    variant: "contained",
                    children: "Get Guidde for free"
                  }
                )
              }
            )
          ]
        }
      )
    }
  );
};
export {
  Ft as P
};
